import CountryPageRenderer from '../components/CountryPageRenderer';
import hungaryData from '../data/country-pages/hungary';

export default function HungaryCountryPage() {
  return <CountryPageRenderer data={hungaryData} />;
}
